module.exports = __webpack_public_path__ + "static/4.7b4d3e16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/4.jpg
// module id = 130
// module chunks = 92919436940798 232045937915672